import { useTranslation } from 'react-i18next';
import type { ProductsStockAlertLevel } from './model/getProductsStockAlert';

interface ProductsStockAlertBannerProps {
    level: ProductsStockAlertLevel;
}

const ProductsStockAlertBanner = ({ level }: ProductsStockAlertBannerProps) => {
    const { t } = useTranslation(['Objects']);
    const ns = 'documents.proposal2Warehouse';

    const message =
        level === 'success'
            ? t(`${ns}.alertStockOk`)
            : level === 'warning'
              ? t(`${ns}.alertStockPartial`)
              : t(`${ns}.alertStockEmpty`);

    return (
        <div className={`alert alert-${level} mx-3 mt-3 mb-3`} role="alert">
            {message}
        </div>
    );
};

export default ProductsStockAlertBanner;
